export const generateEditLinkForPredefinedSearch = id => `/predefinedSearch/edit?predefinedSearchID=${id}`;